export const addRootDiv = (id: string = process.env.ROOT_ID || "widget-chat-v2") => {
    if (!document.getElementById(id)) {
        const rootDiv = document.createElement("div");
        rootDiv.id = id;

        document.body.insertBefore(rootDiv, document.body.firstChild);
    }
};
